import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-carvet-left",
  "use": "arrow-carvet-left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-carvet-left\"><path d=\"M6.152 7.89a.444.444 0 010-.668l3.11-3.111a.444.444 0 01.738.334v6.223c0 .381-.45.586-.737.334L6.152 7.891z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol